export default __webpack_public_path__ + "static/media/catlike170000.0a4be755.png";